<template>
	<div>
		<div class="form-group d-flex align-items-center">
			<h1 class="col-xs-11">
				Users
			</h1>
			<form class="form-inline d-flex ml-auto col-xs-11">
				<input autofocus class="form-control form-control-sm" type="text" placeholder="Search By Name"
					v-model="fullname" />
				<button class="btn btn-primary btn-sm ml-1" type="button" @click="Clear()">Clear</button>
			</form>
		</div>
		<div class="alert alert-danger" v-if="error">
			<p class="mb-0">
				{{ error }}
			</p>
		</div>

		<datatable class="mt-4" :cols="columns" :rows="users.filter(c => fullname ? c.fullname.toLowerCase().includes(fullname.toLowerCase()) : true)" />
	</div>
</template>

<script>
import store from '../../../store';
import { mapState } from 'vuex';
import DataTable from '../../DataTable';
import { createDatatableButtons, getError } from '../../../helpers';

export default {
	components: {
		'datatable': DataTable,
	},

	data() {
		return {
			fullname: null,
			error: null,

			columns: [
				{ headerName: 'ID', field: 'id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 75 },
				{ headerName: 'Fullname', field: 'fullname', sortable: true, filter: true, resizable: true, minWidth: 150, },
				{ headerName: 'Email', field: 'email', sortable: true, filter: true, resizable: true, minWidth: 150, },
				{
					headerName: 'Status',
					field: 'id',
					sortable: false,
					filter: false,
					resizable: true,
					minWidth: 75,
					maxWidth: 100,

					cellRenderer: params => {
						return params.data.banned ? 'Banned' : (params.data.is_verified ? 'Unverified' : 'Active');
					}
				},
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 175,
					maxWidth: 175,

					cellRenderer: params => {
						const buttons = [
							{
								name: 'View',
								type: 'secondary',
								handler: () => {
									this.$router.push({ name: 'view-user', params: { id: params.value } });
								},
							},
						];

						buttons.push({
							name: params.data.banned ? 'Restore' : 'Archive',
							type: params.data.banned ? 'info' : 'danger',
							handler: () => {
								if (confirm('Are you sure you want to toggle this user?')) {
									this.error = null;

									this.$store.dispatch('users/toggle', { userId: params.value })
										.catch(e => {
											this.error = getError(e);
										});
								}
							}
						});

						return createDatatableButtons(buttons);
					}
				}
			],
		};
	},

	computed: {
		...mapState({
			users: state => state.users.users.map(a => ({ ...a })),
		}),
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('users/fetchAll');
		next();
	},
		
    methods: {
        Clear() {
            this.user_name = null;
        }
	},

	meta: {
		title: 'Users',

		meta: [
			{ property: 'og:title', content: 'Users / Al-Shayah' },
		],
	},
};
</script>